import React, { useEffect, useContext, useState } from 'react';
import { bool, node, string } from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import OrderSampleContent from './OrderSampleContent';
import { useOrderSample } from '../hooks/useOrderSample';
import { SampleOverlay } from './SampleOverlay/SampleOverlay';
import './order-sample.scss';

export const OrderSample = ({
  children,
  itemId,
  link,
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('order-sample.ready'); }, []);
  const [overlayOpen, setOverlayOpen] = useState(false);

  const experienceContext = useContext(ExperienceContext);
  const {
    channel,
  } = experienceContext;

  const { storeId, storeZip: zipCode } = useStore();

  const { data, loading } = useOrderSample({ itemId, storeId, zipCode });

  if (!data || loading) {
    return null;
  }

  const {
    price,
    dimensionText,
    hasSample,
    sampleId,
    isSuperSku,
    parentId
  } = data;

  const handleClick = () => {
    if (isSuperSku) {
      setOverlayOpen(true);
    } else {
      const cartReqParams = {
        itemId: sampleId,
        quantity: 1,
        fulfillmentMethod: 'ShipToHome',
        fulfillmentLocation: zipCode
      };

      const cartOptions = {
        channel,
        host: window.location.origin.includes('localhost') ? 'https://www.homedepot.com' : window.location.origin,
        misship: false,
        paypal: false
      };

      window.LIFE_CYCLE_EVENT_BUS.trigger('cart.add-to-cart', {
        cartReqParams,
        cartOptions,
      });
    }
  };

  if (!hasSample) {
    return null;
  }

  return (
    <>
      <Card>
        <OrderSampleContent
          dimensionText={dimensionText}
          link={link}
          price={price}
          handleClick={handleClick}
          multipleSamples={isSuperSku}
        >
          {children}
        </OrderSampleContent>
        <Card.Content>
          <OrderSampleContent
            dimensionText={dimensionText}
            link={link}
            price={price}
            handleClick={handleClick}
            multipleSamples={isSuperSku}
          >
            {children}
          </OrderSampleContent>
        </Card.Content>
      </Card>
      {overlayOpen && (
        <SampleOverlay
          channel={channel}
          dimensionText={dimensionText}
          onClose={() => setOverlayOpen(false)}
          open={overlayOpen}
          parentId={parentId}
          price={price}
          storeId={storeId}
          zipCode={zipCode}
        />
      )}
    </>
  );
};

OrderSample.propTypes = {
  children: node,
  itemId: string.isRequired,
  link: bool,
};

OrderSample.defaultProps = {
  children: 'Order a Sample',
  link: false,
};
